const DEFAULT_PRICING_ALGORITHM = 'default-2022-03-24';

export default DEFAULT_PRICING_ALGORITHM;
